import './EventVCLP.css'; // Custom CSS for hover effect
import { API_BASE_URL } from '../../utils';
import { Link, useParams } from 'react-router-dom';
import React from 'react';


const url = `${API_BASE_URL}/master/assets/uploads/`;

export default React.memo(function Event({ events = [] }) {

   const { club } = useParams();

  
  
  return (
    <div className="vcdp-event-empty-container">
      {events.length === 0 ? (
        <div className="vcdp-event-empty-container">
          <div className="vcdp-event-empty-content">
            <h1>No Upcoming Events</h1>
            <p>
              We currently have no upcoming events scheduled. Please check back later for updates or contact us for more information.
            </p>
            <img
              src="https://illustrations.popsy.co/gray/web-design.svg"
              alt="Coming Soon"
              className="vcdp-event-empty-image"
            />
          </div>
        </div>
      ) : (
        <div className="vcdp-event-container">
          <h1 className="vcdp-event-title">Upcoming Events</h1>
          <div className="vcdp-event-list">
            {events.map((event, index) => (
              <Link
                key={index}
                to={`/${(event.cityName || '').replace(/ /g, '-').toLowerCase()}/${(event.areaName || '').replace(/ /g, '-').toLowerCase()}/${(club || '').trim().split(/ +/).join('-').replace(/ /g, '-').toLowerCase()}/event/${(event.name || '').trim().split(/ +/).join('-').replace(/ /g, '-').toLowerCase()}`}
              >
                <div className="vcdp-event-card-hover">
                  <img
                    src={`${url}${event.image}`}
                    alt={event.name}
                    className="vcdp-event-img"
                  />
                  <div className="vcdp-event-overlay">
                    <h2>{event.name}</h2>
                    <p>{event.categoryName} | {event.areaName}, {event.cityName}</p>
                    <p>{event.event_date} | {event.event_time} - {event.event_end_time}</p>
                    <button className="vcdp-event-book-btn">Book Now</button>
                  </div>
                </div>
              </Link>
            ))}


          </div>
        </div>
      )}
    </div>
  );
});
